import React from 'react';
import { VacationIcon } from '../../../../utils/vacation';

function Header({ title, description }) {
    return (
        <div className="flex items-center gap-4 mb-8">
            <div className="">
                <div className="bg-buttoncolor p-1 rounded-full w-[60px] h-[60px] flex justify-center items-center">
                    <VacationIcon className="" size={24} />
                </div>
            </div>


            <div>
                <h1 className="text-black font-['Roboto_Mono'] text-2xl font-bold ">{title}</h1>
                <p className="text-md text-gray font-quicksand text-[15px] font-normal leading-[18.75px] mt-1 md:whitespace-nowrap">{description}</p>
            </div>
        </div>
    );
}

export default Header;